
import { Component, Vue } from 'vue-property-decorator'
import { availability, maintenanceMessage } from '@/classes/Availability'

/**
 * Shown instead of the app while the API is unreachable or switched to maintenance (BGT-8224). The texts
 * live here rather than in the i18n messages: German and French normally come from the API, which is
 * exactly what is missing now.
 */
const TEXTS: Record<string, { title: string; unavailable: string; maintenance: string; retry: string }> = {
	nl: {
		title: '4shipping is tijdelijk niet beschikbaar',
		unavailable: 'We werken eraan en zijn zo snel mogelijk terug.',
		maintenance: 'We voeren onderhoud uit en zijn zo snel mogelijk terug.',
		retry: 'Deze pagina ververst vanzelf zodra 4shipping weer beschikbaar is.'
	},
	en: {
		title: '4shipping is temporarily unavailable',
		unavailable: "We're working on it and will be back as soon as possible.",
		maintenance: "We're carrying out maintenance and will be back as soon as possible.",
		retry: 'This page refreshes by itself as soon as 4shipping is available again.'
	},
	de: {
		title: '4shipping ist vorübergehend nicht verfügbar',
		unavailable: 'Wir arbeiten daran und sind so schnell wie möglich wieder da.',
		maintenance: 'Wir führen Wartungsarbeiten durch und sind so schnell wie möglich wieder da.',
		retry: 'Diese Seite aktualisiert sich automatisch, sobald 4shipping wieder verfügbar ist.'
	},
	fr: {
		title: '4shipping est temporairement indisponible',
		unavailable: 'Nous y travaillons et serons de retour dès que possible.',
		maintenance: 'Nous effectuons une maintenance et serons de retour dès que possible.',
		retry: 'Cette page se recharge automatiquement dès que 4shipping est de nouveau disponible.'
	}
}

@Component({})
export default class Unavailable extends Vue {
	get texts() {
		return TEXTS[this.$i18n.locale] ?? TEXTS.nl
	}

	get isMaintenance(): boolean {
		return availability.state === 'maintenance'
	}

	get description(): string {
		const custom = this.isMaintenance ? maintenanceMessage(availability.message, this.$i18n.locale) : null

		return custom ?? (this.isMaintenance ? this.texts.maintenance : this.texts.unavailable)
	}
}
